export default {"src":"/_next/static/media/mode_computer_panda.ecfedc41.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};